import { assign } from './utils';
export var SUCCESS_RESULT = 1;
export var HTTP_STATUS_MESSAGE = {
    401: '账号异常，请重新登陆',
    404: '资源未找到，请联系客服',
    408: '请求超时，请稍候再试',
    503: '服务不可用，请稍候再试',
    504: '服务超时，请稍候再试',
    '4xx': '客户端异常，请联系客服',
    '5xx': '服务异常，请联系客服'
};
export var HTTP_STATUS_MESSAGE_RULES = [{
        match: /4(\d{2})$/,
        message: HTTP_STATUS_MESSAGE['4xx']
    }, {
        match: /5(\d{2})$/,
        message: HTTP_STATUS_MESSAGE['5xx']
    }];
export var DEFAULT_ERROR_MESSAGE = '网络异常，请稍候再试';
export var DEFAULT_FORMAT_RESPONSE = function (response) {
    var data = typeof response.data === 'object' && response.data ? response.data : {};
    var res = assign({}, data, {
        response: response,
        result: data.result,
        error_url: data.error_url,
        error_msg: data.error_msg || data.errMsg || data.errorMsg || data.message,
    });
    if (res.result !== SUCCESS_RESULT) {
        res.error_msg = res.error_msg || '出错了，请稍后再试';
        throw res;
    }
    return res;
};
export var DEFAULT_SHOULD_COLLECT_API_ERROR = function (response) {
    var data = typeof response.data === 'object' && response.data ? response.data : {};
    return data.result !== SUCCESS_RESULT;
};
export var NATIVE_NETWORK_ERROR = 'NATIVE_NETWORK_ERROR';
//# sourceMappingURL=constant.js.map